import { mapActions, mapState } from "vuex";
import _ from 'lodash';

export default {
  props: {
    fieldData: {
      type: Object,
      required: true
    },
  },
  computed: {
    name() {
      return this.fieldData.name || ""
    },
    label() {
      return this.fieldData.title || ""
    },
    helpText() {
      return this.fieldData.help_text || ""
    },
    staticLabel() {
      return this.fieldData.static_label || ""
    },
    fieldAttributes() {
      let attributesArray = this.fieldData.attributes;

      let keyedObject = {}

      if (attributesArray != undefined) {
        keyedObject = attributesArray.reduce(
          (obj, item) => Object.assign(obj, { [item.name]: item.value }), {});
      }

      return keyedObject;
    },
    required() {
      return this.fieldData.required || false
    },
    id() {
      return this.name
    },
    setDefault() {
      return _.get(this.event.registrationData, this.fieldData.crm_id);
    },
    showFormError() {
      return this.touched && !this.valid;
    },
    extraClasses() {
      return this.fieldData.class
    },
    ...mapState(['event'])
  },
  data() {
    return {
      value: "",
      touched: false,
      valid: false
    }
  },
  watch: {
    value(newValue) {
      if (this.fieldData.crm_id == null) {
        console.warn('No crm_id set for ', this.fieldData)
      } else {
        let payload = { key: this.fieldData.crm_id, data: newValue };
        this.setRegistrationData(payload);
      }
      this.validateField();
    },
  },
  methods: {
    validateField() {
      this.touched = true;
      this.valid = this.validate();
    },
    validate() {
      // Validate email on form submission
      if (this.fieldData.type == "email") {
        // Taken from: https://vuejs.org/v2/cookbook/form-validation.html#Using-Custom-Validation
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(this.value);
      }

      if (this.required) {
        if (typeof this.value == 'string') {
          return this.value.length > 0;
        }
        else if (typeof this.value === 'boolean') {
          return this.value === true
        } else {
          return false;
        }
      }

      return true;
    },
    ...mapActions(['setRegistrationData']),
  }
}